import { ResourceBuilder } from '../../core/resource-builder'
import type { IncomeToCreate } from './model'

type IncomesRequestsConfig = {
  create: {
    request: IncomeToCreate
    response: number
  }
  delete: {
    request: {
      urlParams: {
        id: number
      }
    }
    response: void
  }
}

export default new ResourceBuilder<IncomesRequestsConfig>('incomes')
